import collect from 'collect.js';
import HelperMethods from '../../../services/exports/HelperMethods';
import { ORDER_PRODUCT_HEIGHT } from '../../../services/exports/Constants';
import { OrderLineItem } from '../../../services/exports/Interfaces';
import useAppMethods from '../../../hooks/utility/useAppMethods';
import classnames from 'classnames';
import useStorefront from '../../../modules/storefront/hooks/useStorefront';

interface Props {
  product: OrderLineItem;
  className?: string;
  toggleProduct: () => void;
}

const MultiOrderProduct = (props: Props): JSX.Element => {
  const { product, className, toggleProduct } = props;
  const { formatCurrency } = useAppMethods();
  const { isStorefront } = useStorefront();

  function getItemPrice(item: OrderLineItem): number {
    return HelperMethods.roundNumberWithPrecision(
      item?.original_price / item?.quantity -
        +collect(item?.modifiers).where('is_available', false).sum('original_price'),
    );
  }

  return (
    <div
      className={classnames(
        'w-full border rounded-2xl flex flex-col cursor-pointer bg-brand-card overflow-hidden p-sm',
        className,
        {
          '!rounded-[8px]': isStorefront,
        },
      )}
      onClick={toggleProduct}
      style={{ height: ORDER_PRODUCT_HEIGHT }}
    >
      <h6 className="font-normal line-clamp-1 break-words mr-md">{product?.name}</h6>
      <div className="flex flex-col flex-1">
        <div className="flex flex-col flex-1">
          {product?.modifiers?.length > 0 && (
            <p className="text-brand-text-secondary line-clamp-1 break-words text-sm mt-[6px]">
              {collect(product?.modifiers)?.implode('name', ' · ')}
            </p>
          )}
          {product?.note && (
            <p className="text-brand-text-secondary text-sm mt-[6px] line-clamp-1 break-words">{product?.note}</p>
          )}
        </div>
        <p className="text-brand-text-secondary">{formatCurrency(getItemPrice(product))}</p>
      </div>
    </div>
  );
};

export default MultiOrderProduct;
